const eventToastMsg = {
  /**
   *  [진행중인 기획전 리스트] 진행중인 기획전 리스트 요청하기
   */
  GET_IN_PROGRESS_AND_EXPOSURE_EVENT_LIST_REQUEST_SUCCESS: '진행중인 기획전와 홈에 노출중인 리스트 요청하기 성공',
  GET_IN_PROGRESS_AND_EXPOSURE_EVENT_LIST_REQUEST_ERROR: '진행중인 기획전와 홈에 노출중인 리스트 요청하기 실패',

  /**
   *  [진행중인 기획전 리스트] 진행중인 기획전 리스트 저장하기
   */
  SAVE_IN_PROGRESS_EVENT_LIST_REQUEST_SUCCESS: '진행중인 기획전 리스트 저장하기 성공',
  SAVE_IN_PROGRESS_EVENT_LIST_REQUEST_ERROR: '진행중인 기획전 리스트 저장하기 실패',

  /**
   *  [진행중인 기획전 리스트] 진행중인 기획전 리스트 요청하기
   */
  GET_IN_PROGRESS_LIST_REQUEST_SUCCESS: '진행중인 기획전 리스트 요청하기 성공',
  GET_IN_PROGRESS_LIST_REQUEST_ERROR: '진행중인 기획전 리스트 요청하기 실패',

  /**
   *  [진행중인 기획전] 진행중인 기획전 리스트 엑셀 다운로드 요청하기
   */
  GET_IN_PROGRESS_EVENT_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '진행중인 기획전 리스트 엑셀 다운로드 요청하기 성공',
  GET_IN_PROGRESS_EVENT_EXCEL_DOWNLOAD_REQUEST_ERROR: '진행중인 기획전 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [전체 기획전] 전체 기획전 리스트 요청하기
   */
  GET_ALL_LIST_REQUEST_SUCCESS: '전체 기획전 리스트 요청하기 성공',
  GET_ALL_LIST_REQUEST_ERROR: '전체 기획전 리스트 요청하기 실패',

  /**
   *  [전체 기획전] 전체 기획전 리스트 엑셀 다운로드 요청하기
   */
  GET_ALL_EVENT_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '전체 기획전 리스트 엑셀 다운로드 요청하기 성공',
  GET_ALL_EVENT_EXCEL_DOWNLOAD_REQUEST_ERROR: '전체 기획전 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [기획전 등록] 기획전 리스트 요청하기
   */
  GET_EVENT_PREPARATION_REQUEST_ERROR: '기획전 리스트 요청하기 실패',

  /**
   *  [기획전 등록] 기획전 상품 excel 리스트 업로드하기
   */
  GET_EVENT_PRODUCT_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '기획전 상품 excel 리스트 다운로드하기 성공',
  GET_EVENT_PRODUCT_EXCEL_DOWNLOAD_REQUEST_ERROR: '기획전 상품 excel 리스트 다운로드하기 실패',

  /**
   *  [기획전 등록] 기획전 상품 excel 리스트 업로드하기
   */
  SET_EVENT_PRODUCT_EXCEL_UPLOAD_REQUEST_SUCCESS: '기획전 상품 excel 리스트 업로드하기 성공',
  SET_EVENT_PRODUCT_EXCEL_UPLOAD_REQUEST_ERROR: '기획전 상품 excel 리스트 업로드하기 실패',

  /**
   *  [기획전 등록] 기획전 등록하기
   */
  INSERT_EVENT_REQUEST_SUCCESS: '기획전 등록하기 성공',
  INSERT_EVENT_REQUEST_ERROR: '기획전 등록하기 실패',

  /**
   *  [기획전 상세] 기획전 상세 가져오기
   */
  GET_EVENT_INFO_REQUEST_SUCCESS: '기획전 상세 가져오기 성공',
  GET_EVENT_INFO_REQUEST_ERROR: '기획전 상세 가져오기 실패',

  /**
   *  [기획전 편집] 기획전 편집 요청하기
   */
  EDIT_EVENT_REQUEST_SUCCESS: '기획전 편집 요청하기 성공',
  EDIT_EVENT_REQUEST_ERROR: '기획전 편집 요청하기 실패',

  /**
   *  [진행중인 기획전, 전체 기획전, 등록, 편집] 태그 리스트 요청하기
   */
  GET_EVENT_TAG_COLUMN_TAG_LIST_REQUEST_ERROR: '기획전 태그 리스트 요청하기 실패',

  /**
   *  [기획전 등록, 편집] 상품 리스트 가져오기
   */
  GET_EVENT_PRODUCT_LIST_REQUEST_ERROR: '상품 리스트 요청하기 실패',

  /**
   *  [기획전 등록, 편집] 태그 리스트 가져오기
   */
  GET_EVENT_TAG_LIST_REQUEST_ERROR: '태그 리스트 요청하기 실패',

  /**
   *  [기획전 등록,편집] 전체 태그 리스트 엑셀 다운로드
   */
  GET_EVENT_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '전체 태그 리스트 엑셀 다운로드 요청하기 성공',
  GET_EVENT_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '전체 태그 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [기획전 등록,편집] 선택 태그 리스트 엑셀 다운로드
   */
  GET_EVENT_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '선택 태그 리스트 엑셀 다운로드 요청하기 성공',
  GET_EVENT_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '선택 태그 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [기획전 등록,편집] 태그 엑셀 업로드
   */
  SET_EVENT_TAG_EXCEL_UPLOAD_REQUEST_SUCCESS: '기획전 태그 excel 리스트 업로드하기 성공',
  SET_EVENT_TAG_EXCEL_UPLOAD_REQUEST_ERROR: '기획전 태그 excel 리스트 업로드하기 실패',
};

export default eventToastMsg;
